import { useEffect, useState } from 'react';

import styles from './index.module.less';

import { useFetch } from '$Hooks';
import { csrfToken, flexibleDateString } from '$Utils';

const GooglePassButton = ({
    first_name,
    last_name,
    birthdate,
    public_uuid,
    queryType
}) => {
    const [query, setQuery] = useState('token');

    useEffect(() => {
        if (queryType === 'patient') {
            setQuery('patient');
        }
        if (queryType === 'staff') {
            setQuery('staff');
        }
    }, []);

    const endpoint = `/api/v2/passes/google/${query}/`;

    const { post } = useFetch(endpoint);

    // Needs a default value for storyshots
    const csrf = csrfToken() || '';
    const birthdateISO = flexibleDateString(birthdate, null, 'ISO');
    const imagePath = `${process.env.STATIC}img/_badges/google/en/`;
    const imageFile = 'google_savetophone_black_en.svg';

    const postPass = () => {
        let postData = { public_uuid, csrfmiddlewaretoken: csrf };
        if (queryType === 'token') {
            postData.first_name = first_name;
            postData.last_name = last_name;
            postData.birthdate = birthdateISO;
        }

        post(postData).then(response => {
            // let's try this
            window.location.assign(response.jwt_url);
        });
    };

    return (
        <div
            className="apple-pass-button"
            style={{ textAlign: 'center', marginTop: '1em' }}
        >
            <button
                onClick={postPass}
                className={styles['google-button']}
                type="button"
            >
                <img
                    src={`${imagePath}${imageFile}`}
                    width="240px"
                    alt="Add to Google Pay"
                />
            </button>
        </div>
    );
};

export default GooglePassButton;
